// @flow
import React from 'react';
import { connect } from 'react-redux';

import * as selectors from '../../reducers';
import Loader from '../Loader';
import styles from './mapStatus.css';


const DummyMapStatus = ({ isLoading = false, message }) => (
  message
  && (
    <div className={styles.mapStatus}>
      { isLoading && <Loader tint="gray" size="small" /> }
      <div className={styles.message}>
        { message }
      </div>
    </div>
  )
);


export default connect(
  state => ({
    isLoading: selectors.isMapLoading(state),
    message: selectors.getMapLoadingMessage(state),
  }),
  undefined,
)(DummyMapStatus);



// WEBPACK FOOTER //
// ./src/scripts/components/MapStatus/index.jsx